(function ($) {

  const $body = $('body');
  const $header = $('#site-header');
  const $menu = $('#menu-wrap');
  const $toggle = $('#mobile-menu-toggle');
  const speed = 300;

  const menu_bp = $header.data('menu-bp');


  function is_mobile() {
    return $toggle.is(':visible');
  }


  // create focus trap
  const focus_trap = focusTrap.createFocusTrap($header.get(0), {
    onActivate() {
      $toggle.addClass('is-active');
      $menu.addClass('visible');
      $body.addClass('menu-open');
    },
    onDeactivate() {
      $toggle.removeClass('is-active');
      $body.removeClass('menu-open');
      setTimeout(function () {
        $menu.removeClass('visible');
      }, speed);
    },
    initialFocus: $toggle.get(0),
  });


  function resize() {
    $header.toggleClass('mobile', !ThemeJS.Media_Queries.is_at_least(menu_bp));
    var header_pad = $header.outerHeight() + $('.sitewide-banner').outerHeight();
    // if ($body.hasClass('admin-bar') && $('#wpadminbar').length) {
    // header_pad += $('#wpadminbar').outerHeight();
    // }
    document.querySelector(':root').style.setProperty('--actual-header-height', `${$header.outerHeight()}px`);
    document.querySelector(':root').style.setProperty('--header-height', `${header_pad}px`);
    $menu.removeClass('mobile-transition-enabled');
    setTimeout(function () {
      $menu.addClass('mobile-transition-enabled');
    }, 0);
    if (ThemeJS.Media_Queries.is_at_least(menu_bp)) {
      focus_trap.deactivate();
      $('button.sub-menu-toggle').closest('li').each(function () {
        set_submenu_open($(this), false);
      });
    }
  }

  // if $header === fixed or absolute, add padding to offset sitewide-banner height
  // and smoothly move header down if WP admin bar exists.
  function handleSitewideBanner() {
    const $banner = $('.sitewide-banner');
    if (!$banner.length) return;

    const hasFixedOrAbsolute = $header.hasClass('fixed') || $header.hasClass('absolute');
    if (!hasFixedOrAbsolute) return;

    function getAdminBarHeight() {
      const bar = document.getElementById('wpadminbar');
      return bar ? bar.offsetHeight : 0;
    }

    // Update top position based on scroll distance
    function updateBannerOffset() {
      const bannerHeight = $banner.outerHeight();
      if (bannerHeight === 0) return;

      const scrollTop = $(window).scrollTop();
      const adminBarHeight = getAdminBarHeight();

      // Banner offset: header moves up as you scroll until banner is hidden
      const bannerOffset = Math.max(0, bannerHeight - scrollTop);

      // Final top offset = admin bar + banner offset
      const topValue = adminBarHeight + bannerOffset;

      $banner.css('top', `${adminBarHeight}px`);

      $header.css('top', `${topValue}px`);
    }

    // Initial run
    updateBannerOffset();

    // Scroll updates
    $(window).on('scroll.sitewide-banner', updateBannerOffset);

    // Resize updates (banner height or admin bar height can change)
    $(window).on('resize.sitewide-banner', updateBannerOffset);
  }


  // init header pad height and set header to fixed
  resize();
  $header.addClass('fixed');
  handleSitewideBanner();
  // trigger height recalculation on breakpoint change
  $(window).on('breakpoint_changed', resize);

  // New: Watch for wpadminbar being added
  const adminBarObserver = new MutationObserver(() => {
    if (document.getElementById('wpadminbar')) {
      resize();
      handleSitewideBanner();
      adminBarObserver.disconnect();
    }
  });

  adminBarObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  // toggle mobile menu on hamburger click
  $toggle.click(() => {
    $body.hasClass('menu-open') ? focus_trap.deactivate() : focus_trap.activate();
  });


  // function to set submenus open/close
  function set_submenu_open($li, opening) {
    let $btn = $('> .link-wrap button.sub-menu-toggle', $li);
    if (!$btn.length) { return; }
    let $submenu = $(`#${$btn.attr('aria-controls')}`);
    if (!$submenu.length) { return; }
    $btn.attr('aria-expanded', opening ? 'true' : 'false');
    $submenu.attr('aria-hidden', opening ? 'false' : 'true')[opening ? 'slideDown' : 'slideUp'](speed);
  }


  // toggle submenus on click of caret btns
  $menu.on('click', 'button.sub-menu-toggle', function () {
    set_submenu_open($(this).closest('li'), $(this).attr('aria-expanded') == 'false');
  });


  // close submenu on tab out
  $menu.on('focusout', 'li.menu-item-has-children', function (e) {
    if (is_mobile() || $.contains(this, e.relatedTarget)) { return; }
    set_submenu_open($(this), false);
  });


  // treat click of a custom link '#' menu item as clicking its submenu toggle
  $menu.on('click', 'a[href="#"]', function (e) {
    e.preventDefault();
    let $btn = $('+ .sub-menu-toggle', this);
    if ($btn.length) {
      $btn.click();
    }
  });

})(jQuery);
